import React from "react";
import SiteAnalyticsPageDropdowns from "./SiteAnalyticsPageDropdowns";
import ContentForPage from "../../containers/ContentForPage";
import PageLayout from "../UI/PageLayout";

const SiteAnalyticsPage = () => {
    return (
        <PageLayout
            title="Site Analytics"
            dropdowns={<SiteAnalyticsPageDropdowns />}
            content={[
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        height: "100%",
                    }}
                >
                    <ContentForPage pageName={"site_analytics"} />
                </div>,
            ]}
        />
    );
};

export default SiteAnalyticsPage;
